import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import QuickFix from './QuickFix';
interface props {
  item: SmartSendItemApiModel;
  error: string;
  children: React.ReactNode;
}
const QuickFixWrapper: React.FC<props> = (props) => {
  return <QuickFix item={props.item} children={props.children} error={props.error} />;
};
export default QuickFixWrapper;
